import { Injectable } from '@angular/core';
import { ApiConService } from '../shared/api-con.service';
import { JsonReturn, ObjectParam } from '../interface/generic-interface';

@Injectable({
  providedIn: 'root'
})
export class AvaliacaoService {

  exibirModalAvaliacao: boolean = false;

  constructor(private conService: ApiConService) { }

  async getAvaliacaoPesquisa(momento: string) {
    try {
      const response: JsonReturn = await this.conService.patch(
        `DCAvaliacaoPesquisa/momento-projeto/${momento}/OCORRENCIAS`
      );
      return response.response;
    } catch (err) {
      console.log("CATCH________DCAvaliacaoPesquisa");
      console.log(err);
    }
  }

  async getAvaliacaoPesquisaItem(avaliacaoID: number) {
    try {
      const response: JsonReturn = await this.conService.patch(`DCAvaliacaoPesquisaItem/${avaliacaoID}`);
      return response.response;
    }catch (Error) {
      console.log("CATCH________DCAvaliacaoPesquisaItem");
      console.log(Error);
    }
  }

  async salvarRespostaAvaliacao(objParam: ObjectParam){
    try {
      const response: JsonReturn = await this.conService.post('DCAvaliacaoPesquisaResultado', objParam);
      return response.response;
    }catch (e) {
      console.log(e);
    }
  }
}
